import {Component, Input, OnInit} from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-sharing',
  templateUrl: './sharing.component.html',
  styleUrls: ['./sharing.component.css']
})
export class SharingComponent implements OnInit {

  pageURL = '';
  pageFeaturedImage = '';

  @Input()
  get PageURL(): string {
    return this.pageURL;
  }

  set PageURL(url: string) {
    this.pageURL = url;
  }

  @Input()
  get PageFeaturedImage(): string {
    return this.pageFeaturedImage;
  }

  set PageFeaturedImage(url: string) {
    this.pageFeaturedImage = url;
  }

  constructor() {
  }

  ngOnInit(): void {
  }

  openShareLink(): void {
    $('.sharelink').toggle();
  }


}
